import { render, staticRenderFns } from "./BorrowerDetailModal.vue?vue&type=template&id=19ebdd00&scoped=true"
import script from "./BorrowerDetailModal.vue?vue&type=script&lang=js"
export * from "./BorrowerDetailModal.vue?vue&type=script&lang=js"
import style0 from "./BorrowerDetailModal.vue?vue&type=style&index=0&id=19ebdd00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ebdd00",
  null
  
)

export default component.exports